<template>
  <div class="cl">
    <div class="game_slide cl">
      <div class="swiper-container" id="s2">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in GameList"
            :key="index"
          >
            <a :href="item.offical_url" target="_blank" class="img_game_warp">
              <img :src="item.game_bg" alt="" />
              <div class="mask cl">
                <div class="head z">
                  <img :src="item.game_icon" alt="" />
                </div>
                <div
                  class="z twarp"
                  :class="
                    item.game_title.replace(/[^\x00-\xff]/g, '01').length > 19
                      ? ''
                      : 'on'
                  "
                >
                  <div
                    class="ell2 title_g title"
                    v-html="item.game_title"
                  ></div>
                  <div class="hrf">{{ $t("btn.website") }}</div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <!-- 左右切换 -->
      <div class="prevCont">
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev gprev"></div>
        <div class="swiper-button-next gnext"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  name: "Games",
  components: {},
  props: ["GameList"],
  data() {
    return {
      isStop: false, //是否停止动画
      s2: "", //banner
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    getG() {
      let that = this;
      this.$nextTick(function () {
        that.s2 = new Swiper("#s2", {
          autoplay: false,
          loop: false,
          navigation: {
            nextEl: ".prevCont .gnext", //自动隐藏
            prevEl: ".prevCont .gprev", //自动隐藏
            hiddenClass: "btn-hidden", //某些情况下需要隐藏前进后退按钮时，可以设定一个自定义的类名。
          },
          slidesPerView: 4,
          spaceBetween: 40,
          breakpointsInverse: true,
          breakpoints: {
            0: {
              //当屏幕宽度大于等于320
              slidesPerView: 1,
              spaceBetween: 20,
            },
            800: {
              //当屏幕宽度大于等于320
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1200: {
              //当屏幕宽度大于等于768
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1930: {
              //当屏幕宽度大于等于1920
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        });
      });
    },
  },
  watch: {
    GameList() {
      this.getG();
    },
  },
};
</script>
<style scoped>
.game_slide {
  overflow: hidden;
  margin: 0 auto;
  margin-top: 0;
  text-align: center;
  position: relative;
}

.swiper-button-prev.gprev:after,
.swiper-button-next.gnext:after {
  color: #fff;
  font-weight: 700;
}

.swiper-button-disabled.gnext,
.swiper-button-disabled.gprev {
  display: none;
}
.title_g {
  white-space: pre-wrap; /* css-3 */
}
</style>













// WEBPACK FOOTER //
// src/components/Games.vue